module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#hero'),
      expression: "'#hero'"
    }],
    staticClass: "nav-item"
  }, [_c('span', {
    staticClass: "logo-text"
  }, [_vm._v(_vm._s(_vm.logo))])])]), _vm._v(" "), _c('span', {
    staticClass: "nav-toggle",
    class: {
      'is-active': _vm.isExpanded
    },
    on: {
      "click": function($event) {
        _vm.isExpanded = !_vm.isExpanded
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('div', {
    staticClass: "nav-right nav-menu",
    class: {
      'is-active': _vm.isExpanded
    }
  }, _vm._l((_vm.menuItems), function(item) {
    return _c('a', {
      key: item.id,
      staticClass: "nav-item",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.goTo(item)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.title) + "\n      ")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bba080b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 542
// module chunks = 1